// Screenreader text in sr-only span will display when running locally but is hidden when component is used
// in sites using Bootstrap.

import React from "react";

const BetaBanner = ({ displayBetaBanner, feedbackFormUrl }) => {
  if (displayBetaBanner) {
    return (
      <div className="phase-banner page">
        <div className="container-fluid">
          <p>
            <strong className="phase-tag">BETA</strong>
            <span>
              This is a new service - your{" "}
              <a href={feedbackFormUrl} rel="noreferrer" target="_blank">
                feedback<span className="sr-only"> on this chatbot</span>
              </a>{" "}
              will help us to improve it.
            </span>
          </p>
        </div>
      </div>
    );
  } else {
    console.log("Beta banner disabled");
    return null;
  }
};

export default BetaBanner;
